const NHS_NUMBER = /\b\d{3}[\s-]?\d{3}[\s-]?\d{4}\b/;
const CLINICAL_CODE = /\b(?:VOL|VID|SCR|SCN|SUBJ|PTID|PID)[-_ ]?\d{3,}\b/i;
const CLINICAL_LABEL =
  /\b(?:volunteer|participant|subject|screening|patient)\s*(?:id|no\.?|number|#)\b|\bnhs\s*number\b|\bdate\s*of\s*birth\b|\bmedical\s*record\b|\bnational\s*insurance\b/i;
const LONG_DIGIT_RUN = /\d{8,}/;
const EMAIL = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
const NON_ENGLISH =
  /[\u0900-\u097F\u0600-\u06FF\u0400-\u04FF\u4E00-\u9FFF\u3040-\u30FF\uAC00-\uD7AF]/;

export function validateFaqAiQuestion(
  question,
  { maxLength = 1000, maxLineBreaks = 6 } = {},
) {
  const text = String(question || "");
  if (text.length > maxLength) {
    return `Please shorten your question (maximum ${maxLength} characters).`;
  }

  const lineBreaks = (text.match(/\r\n|\n|\r/g) || []).length;
  const tabs = (text.match(/\t/g) || []).length;
  if (lineBreaks > maxLineBreaks || tabs > 2) {
    return "Please paste a short how-to question only. Do not paste lists, tables, or clinical records.";
  }

  if (NON_ENGLISH.test(text) || !hasEnoughEnglish(text)) {
    return "Please ask in English. The FAQ assistant only answers in English.";
  }

  const emails = text.match(EMAIL) || [];
  if (
    NHS_NUMBER.test(text) ||
    CLINICAL_CODE.test(text) ||
    CLINICAL_LABEL.test(text) ||
    LONG_DIGIT_RUN.test(text) ||
    emails.length >= 2
  ) {
    return "Do not include clinical identifiers (for example volunteer IDs, screening numbers, or NHS numbers). Ask how to use the product instead.";
  }

  return "";
}

function hasEnoughEnglish(text) {
  const letters = String(text || "").match(/\p{L}/gu) || [];
  if (!letters.length) return true;
  const latin = letters.filter((ch) => /[A-Za-z]/.test(ch)).length;
  return (latin * 100) / letters.length >= 80;
}
